import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContentContext = createContext(null);

export function SiteContentProvider({ children }) {
    const [content, setContent] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/site-content");
            setContent(data);
        } catch {
            setContent({}); // fall back to per-page defaults
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <SiteContentContext.Provider value={{ content, refresh, setContent }}>
            {children}
        </SiteContentContext.Provider>
    );
}

export function useSiteContent() {
    return useContext(SiteContentContext);
}

// Resolve a section or fall back to provided defaults (also merges missing fields for objects).
export function useSection(section, defaults) {
    const ctx = useContext(SiteContentContext);
    const value = ctx?.content?.[section];
    if (value == null) return defaults;
    if (Array.isArray(defaults)) return Array.isArray(value) ? value : defaults;
    if (defaults && typeof defaults === "object") return { ...defaults, ...value };
    return value ?? defaults;
}
